import { createSelector } from 'reselect'

import { selectPartner360Data } from './selectPartner360Data'

export const selectAvailableOfferings = createSelector(
  [selectPartner360Data],
  ({ programOfferings }) => programOfferings
)
